import axios from 'axios'

export default {
    state: {
        reports: [],
        currentReport: null,
        //{
        //     reportId: "7314d474-1cc6-4fd3-42e7-08d941f6d33f",
        //     reportPeriodName: "2021 Q2",
        //     reportPeriodId: "ace0561b-68ee-420e-1515-08d908a57e9d",
        //     creditInstituteId: "ed95f0f8-cbff-4cd4-317b-08d908a09c78",
        //     creditInstituteName: "Black Bank",
        //     submissionStatus: "submittedToHCMC",
        //     hcmcEmployees: "hcmc1Epitheto11 hcmc1Onoma",
        //     submittedVersionId: "47e18234-d07a-41ba-9f18-08d9c07bdf99",
        //     lastUploadedVersionId: "47e18234-d07a-41ba-9f18-08d9c07bdf99",
        //     lastUploadedVersionDate: "2021-12-16T12:07:31.4250928"
        // },
        //todo return to null
        currentRoute: '',
        totalPageCount: 0,
        xmlErrors: '',
        savedReport: '',
        uploadedReport: '',
        pendingReports: '',
        showReport: '',
        showResponse: '',
        reportHistory: [],
        missingReports: [],
        currentReportVersion: {},
    },

    getters: {
        currentReportDate: state => new Date(state.currentReport.lastUploadedVersionDate).toLocaleDateString('el'),
        hasErrors: function (state) {
            if (state.uploadedReport.xmlErrors == undefined)
                return false
            else return true
        }
    },

    mutations: {
        getReports(state, reports) {
            state.reports = reports
        },

        setCurrentReport(state, report) {
            state.currentReport = report
        },

        setCurrentRoute(state, route) {
            state.currentRoute = route
        },

        setTotalPageCount(state, count) {
            state.totalPageCount = parseInt(count, 10)
        },

        getXmlErrors(state, errors) {
            state.xmlErrors = errors
        },

        getSavedReport(state, report) {
            state.savedReport = report
        },

        getUploadedReport(state, report) {
            state.uploadedReport = report

        },

        getPendingReports(state, reports) {

            state.pendingReports = reports

        },

        showReport(state, report) {
            state.showReport = report;
        },

        showResponse(state, response) {
            state.showResponse = response;
        },

        getReportHistory(state, history) {

            state.reportHistory = history
        },

        getMissingReports(state, reports) {
            state.missingReports = reports
        },

        setCurrentReportVersion(state, reportVersion) {
            state.currentReportVersion = reportVersion
        }

    },

    actions: {
        async getReports({ commit }, pageNumber) {
            try {
                const reports = await axios.get(`${process.env.VUE_APP_BASE_URL}/CredInst/GetReports`)
                // commit('setTotalPageCount', reports.data.totalPageCount)
                commit('getReports', reports.data.results)
            }
            catch (e) {
                throw e;
            }

        },

        async uploadReport({ commit }, payload) {
            try {
                const result = await axios.post(`${process.env.VUE_APP_BASE_URL}/CredInst/ValidateReport`, payload)
                if (result?.data?.xmlErrors) {
                    for (let i = 0; i < result.data.xmlErrors.length; i++) {
                        result.data.xmlErrors[i].uid = i;

                    }
                    commit('getUploadedReport', result.data)

                }
                else
                    commit('getUploadedReport', result.data)
            }
            catch (e) {
                throw e
            }
        },

        async getXmlErrors({ commit }, id) {
            try {
                const result = await axios({
                    method: 'post',
                    url: `${process.env.VUE_APP_BASE_URL}/Report/ReportErrorTextFile`,
                    responseType: 'arraybuffer',
                    data: {
                        errorpath: id,
                        validpath: ''
                    }

                },)
                commit('getXmlErrors', result.data)
            }
            catch (e) {
                throw e;
            }

        },

        async getSavedReport({ commit }, id) {
            try {

                const result = await axios({
                    method: 'get',
                    url: `${process.env.VUE_APP_BASE_URL}/report/ReportVersionXml/${id}`,
                    responseType: 'arraybuffer'
                })

                commit('getSavedReport', result)
            }
            catch (e) {
                throw e;
            }

        },

        async submitReport({ }, id) {
            try {
                const result = await axios.post(`${process.env.VUE_APP_BASE_URL}/credinst/SubmitReport`, {
                    reportVersionId: id
                })
            }
            catch (e) {
                throw e
            }
        },

        async getPendingReports({ commit }) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/credinst/getpendingreports`)
                commit('getPendingReports', result.data)
            }
            catch (e) {
                throw e
            }
        },

        async showReport({ commit }, id) {

            try {
                const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/report/ReportHtml/${id}`)
                commit('showReport', result.data)

            }
            catch (e) {
                throw e
            }

        },

        async showResponse({ commit }, id) {

            try {
                const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/Report/ResponseHtml/${id}`)
                commit('showResponse', result.data)

            }
            catch (e) {
                throw e
            }

        },

        async getReportHistory({ commit }, id) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/report/history/${id}`)

                commit('getReportHistory', result.data)
            }
            catch (e) {
                throw e
            }
        },

        async getMissingReports({ commit }) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/HCMC/GetMissingReports`)
                commit('getMissingReports', result.data)
            }
            catch (e) {
                throw e
            }
        }


    }
}